// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".tag-cls{background:rgba(19,181,232,.1);border:none;border-radius:0;color:#303030}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
